﻿import { Pipe, PipeTransform } from "@angular/core";
import * as _ from "lodash";

@Pipe({
    name: "searchCasesFilter",
})
export class SearchCasesFilterPipe implements PipeTransform {

    arrquery: any[];
    temparray: any[];

    startsWith(char, stringvalue) {
        if (stringvalue == null)
            return false;
        
        if ((stringvalue.toUpperCase().substring(0, char.length)) == char)
            return true;
        else
            return false;
    } 


    transform(array: any[], query: string): any {
      
        this.arrquery = query.split(",");
        this.temparray = array;
        for (var qry in this.arrquery) {
            var qryvalue = this.arrquery[qry];
            if (qryvalue && qryvalue != "undefined") {

                let arrVal = qryvalue.split("~");
                if ((arrVal[1] && arrVal[1] != "undefined")) {
                    arrVal[1] = arrVal[1].trim();
                    arrVal[1] = arrVal[1].toUpperCase();
                    switch (arrVal[0]) {
                    case "CaseNumber":
                            this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.CaseNumber)));
                            break;
                    case "FirstName":
                            this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.FirstName))); 
                            break;
                    case "MiddleName":
                          //  this.temparray = _.filter(this.temparray, (row) => (!!row.MiddleName ? row.MiddleName.toUpperCase().indexOf(arrVal[1]) > -1 : !!row.MiddleName));
                            this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.MiddleName)));
                            break;
                    case "LastName":
                            this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.LastName)));
                            break;
                    case "DOB":
                            this.temparray = _.filter(this.temparray, (row) => (!!row.DOB ? row.DOB.indexOf(arrVal[1]) > -1 : !!row.DOB));
                            break;
                    case "Sex":
                          this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.Sex)));
                          break;
                    case "CaseType":
                          this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.CaseType)));
                          break;
                    case "FileNumber":
                            this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.FileNumber)));
                          break;
                    case "ChildNumber":
                          this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.ChildNumber)));
                          break;
                    case "Location":
                          this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.Location)));
                          break;
                    case "JudicialOfficer":
                          this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.JudicialOfficer)));
                          break;
                    case "HearingDateTime":
                            this.temparray = _.filter(this.temparray, (row) => (!!row.HearingDateTime ? row.HearingDateTime.toUpperCase().indexOf(arrVal[1]) > -1 : !!row.HearingDateTime));
                            break;
                    case "HearingType":
                            this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.HearingType)));
                            break;
                    case "SWIDNumber":
                            this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.SWIDNumber)));
                            break;
                    case "Location":
                        this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.Location)));
                        break;
                    case "Judge":
                        this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.JudicialOfficer)));
                        break;
                    default:
                    }
                }
            }
        }
        return this.temparray;
    }

}





